(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rebuild-departments"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('focusin', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('#rebuild-home .collection__item > a, #rebuild-home .rebuild-project-guides__card');
    if (!link) return;
    const rail = link.closest('.collection-list__content, .rebuild-project-guides__list');
    if (!rail || rail.scrollWidth <= rail.clientWidth) return;
    const item = link.getBoundingClientRect();
    const viewport = rail.getBoundingClientRect();
    if (item.left < viewport.left || item.right > viewport.right) rail.scrollLeft += item.left - viewport.left;
  });

  } catch(e) { console.error(e); }
})();
})();
